<template>
    <div>
        <div class="grid grid-cols-3 gap-x-3 gap-y-2 py-1">
            <!-- Item -->
            <div class="col-span-3 md:col-span-1">
                <el-autocomplete
                    id="issueFormItem"
                    class="w-full"
                    :class="{'is-invalid': errors.item !== ''}"
                    v-model="issueForm.item"
                    :fetch-suggestions="itemNamesListSearch"
                    placeholder="Enter item name">
                </el-autocomplete>
                <span
                    class="invalid-feedback"
                    :class="{'d-block': errors.item !== ''}"
                    v-show="errors.item !== ''">
                    {{ errors.item }}
                </span>
            </div>
            <!-- Location -->
            <div class="col-span-3 md:col-span-1">
                <el-autocomplete
                    v-model="issueForm.location"
                    class="w-full"
                    :fetch-suggestions="areaNamesListSearch"
                    placeholder="Enter location name">
                </el-autocomplete>
            </div>
            <!-- Required Action -->
            <div class="col-span-3 md:col-span-1">
                <el-select
                    v-model="issueForm.required_action"
                    class="w-full"
                    :class="{'is-invalid': errors.required_action !== ''}"
                    placeholder="Required Action">
                    <el-option
                        v-for="(option, index) in actionTypes"
                        :key="index"
                        :label="option"
                        :value="option">
                    </el-option>
                </el-select>
                <span
                    class="invalid-feedback"
                    :class="{'d-block': errors.required_action !== ''}"
                    v-show="errors.required_action !== ''">
                    {{ errors.required_action }}
                </span>
            </div>
            <!-- Description -->
            <div class="col-span-3">
                <text-area
                    input-label=""
                    class="w-full"
                    v-model="issueForm.description"
                    placeholder="Description"
                    rows="1"
                    :max-length="1000"
                    :resizable="false">
                </text-area>
            </div>
        </div>

        <!-- Buttons -->
        <div v-if="mode === 'create'" class="flex flex-col items-center sm:flex-row sm:justify-between sm:items-center">
            <span class="text-gray-400 text-xs">{{ descriptionCharacterCount }}</span>
            <button class="text-indigo-600 hover:text-indigo-800 flex items-center" @click.prevent="createNewIssueItem()">
                Finalize Issue
            </button>
        </div>

        <div v-else class="flex justify-end">
            <button class="text-red-600 hover:text-brand flex items-center mr-4" @click.prevent="deleteIssue">
                <icon-trash class="w-4 h-4 mr-1"></icon-trash>
                Remove Issue
            </button>
            <button class="text-green-500 hover:text-green-700 flex items-center" @click.prevent="updateIssue">
                <icon-check class="w-4 h-4 mr-1"></icon-check>
                Update Issue
            </button>
        </div>
    </div>
</template>

<script>
import AreasMixin from "../../../mixins/area-name-list-search";
import ItemsMixin from "../../../mixins/item-name-list-search";
import IssueMixin from "../../../mixins/issues-mixin";

export default {
    name: "TicketIssueForm",
    mixins: [AreasMixin, ItemsMixin, IssueMixin],

    props: {
        assignedIssue: {
            type: Object,
            default: () => {
                return {};
            },
            description: "The Issue passed in when editing an issue"
        },
    },

    data () {
        return {
            issueForm: {
                item: "",
                location: "",
                description: "",
                required_action: ""
            },
            errors: {
                item: "",
                required_action: ""
            },
            mode: "create",
        };
    },

    computed: {
        descriptionCharacterCount () {
            if (this.issueForm && this.issueForm.description) {
                return 1000 - this.issueForm.description.length;
            }

            return 1000;
        }
    },

    watch: {
        assignedIssue () {
            if (Object.keys(this.assignedIssue).length === 0) {
                this.resetIssueForm();
                this.mode = "create";
            } else {
                this.issueForm = this.assignedIssue;
                this.mode = "edit";
            }
        },
        issueForm: {
            deep: true,
            handler () {
                this.resetFormErrors();
            }
        }
    },

    methods: {
        createNewIssueItem (autoCreating = false) {
            if (autoCreating) {
                if (this.issueForm && this.issueForm.item && this.issueForm.required_action) {
                    this.addIssueAndResetForm();
                }
            } else if (this.validateIssueForm()) {
                this.addIssueAndResetForm();
                document.getElementById("issueFormItem").focus();
            }
        },

        addIssueAndResetForm () {
            this.$emit("add-new-issue", this.issueForm);
            this.resetIssueForm();
        },

        updateIssue () {
            if (!this.validateIssueForm()) {
                return false;
            }
            this.$emit("edit-issue", this.issueForm.issueIndex, this.issueForm);
            this.resetIssueForm();
        },

        deleteIssue () {
            this.$emit("remove-issue", this.issueForm.issueIndex);
            this.resetIssueForm();
        },

        validateIssueForm () {
            let issueFormIsValid = true;

            if (this.issueForm.item.trim() === "") {
                this.errors.item = "The item name is required.";
                issueFormIsValid = false;
            }

            if (this.issueForm.required_action.trim() === "") {
                this.errors.required_action = "The required action is required.";
                issueFormIsValid = false;
            }

            if (this.issueForm.description.length > 1000) {
                this.errors.description = "The description length may not be more than 1000 characters.";
                issueFormIsValid = false;
            }

            return issueFormIsValid;
        },

        resetIssueForm () {
            this.issueForm = {
                item: "",
                location: "",
                description: "",
                required_action: ""
            };
            this.resetFormErrors();
        },

        resetFormErrors () {
            this.errors = {
                item: "",
                required_action: ""
            };
        },
    },
};
</script>

<style scoped>

</style>